export const getLocalizationMapping = `query ParameterLocalization($filter: ParameterLocalizationRequest!) {
  parameterLocalization(filter: $filter) {
    localizationParameter {
      pkId
      version
      region
      productFamily
      productGroup
      parameterKey
      parameterValue
      parameterText
      comments
      status
      createdBy
      whoChanged
      lastModifiedDate
    }
  }
}`;